// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agency-header[data-v-686b204a]{height:120px;margin-bottom:50px}.agency-bar[data-v-686b204a]{background-image:url(/common/assets/images/55investigations_logo.svg);background-repeat:none;background-size:59.3px 33.61px;background-position-x:16.35px;background-position-y:center}.home-icon[data-v-686b204a]{margin-right:20px!important}.case-bar[data-v-686b204a]{background:rgba(0,0,0,.5019607843137255);box-shadow:0 8px 9px 0 rgba(0,0,0,.32941176470588235)}", ""]);
// Exports
module.exports = exports;
